import React from 'react';
import Paper from './Paper';
import './App.css';
import Orientations from './Orientations';
import domtoimage from 'dom-to-image';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlusCircle, faDownload, faArrowsAltH, faArrowsAltV, faArrowLeft, faArrowRight, faArrowUp, faArrowDown, faBomb, faImage, faPortrait } from '@fortawesome/free-solid-svg-icons'

const defaultFrame = {width: 60, height: 120, left: 20, top: 20};

class App extends React.Component {

	constructor(props) {
		super(props);
		const initFrames = [
			Object.assign({}, defaultFrame)
		];
		this.state = {
			frames: initFrames,
			selectedFrame: null,
			orientation: Orientations.A4.landscape
		};
	}

	selectFrame = frame => () => {
		this.setState({selectedFrame: frame});
	}

	createFrame = () => {
		const { frames } = this.state;
		const lastFrame = frames[frames.length-1] || defaultFrame;
		const newFrame = {width: lastFrame.width, height: lastFrame.height, left: lastFrame.left + 20, top: lastFrame.top + 20};
		frames.push(newFrame);
		this.update(newFrame, newFrame, frames);
	}

	update = (newFrame, originalFrame, frames) => {
		const newFrames = frames.map(f => f===originalFrame ? newFrame : f);
		this.setState({frames: newFrames, selectedFrame: newFrame});
	}


	scaleUpX = () => {
		const { selectedFrame, frames } = this.state;
		const newFrame = Object.assign({}, selectedFrame);
		newFrame.width += 10;
		this.update(newFrame, selectedFrame, frames);
	}

	scaleDownX = () => {
		const { selectedFrame, frames } = this.state;
		const newFrame = Object.assign({}, selectedFrame);
		newFrame.width -= 10;
		this.update(newFrame, selectedFrame, frames);
	}

	scaleUpY = () => {
		const { selectedFrame, frames } = this.state;
		const newFrame = Object.assign({}, selectedFrame);
		newFrame.height += 10;
		this.update(newFrame, selectedFrame, frames);
	}

	scaleDownY = () => {
		const { selectedFrame, frames } = this.state;
		const newFrame = Object.assign({}, selectedFrame);
		newFrame.height -= 10;
		this.update(newFrame, selectedFrame, frames);
	}

	clear = () => {
		this.setState({frames: [], selectedFrame: null})
	}

	save = () => {
		this.setState({selectedFrame: null}, () => {
			const node = document.getElementById('paper');
			const origMarg = node.style.margin;
			const origBorder = node.style.border;
			const origBoxShadow = node.style.boxShadow;
			node.style.margin="0";
			node.style.border="none";
			node.style.boxShadow = "none";
			domtoimage.toPng(node)
			.then(function (dataUrl) {
				const link = document.createElement('a');
				const date = new Date();
				link.download = `comic-frames${date.valueOf()}.png`;
				link.href = dataUrl;
				link.click();
			})
			.catch(function (error) {
				console.error('oops, something went wrong!', error);
			})
			.finally(() => {node.style.margin = origMarg; node.style.border = origBorder; node.style.boxShadow = origBoxShadow;});
		})
	}

	changeOrientation = () => {
		const {orientation} = this.state;
		const newOrientation = orientation === Orientations.A4.landscape ? Orientations.A4.portrait : Orientations.A4.landscape;
		this.setState({orientation: newOrientation});
	}

	render() {
		const { frames, selectedFrame, orientation } = this.state;
		return (
		  <div className="comic-app">
		    <header className="comic-app-header">
					<button onClick={this.changeOrientation}><FontAwesomeIcon icon={orientation===Orientations.A4.landscape ? faPortrait : faImage} /></button>
					<button onClick={this.createFrame}><FontAwesomeIcon icon={faPlusCircle} /></button>
					<button onClick={this.scaleUpX}><FontAwesomeIcon icon={faArrowsAltH} /></button>
					<button onClick={this.scaleDownX}><FontAwesomeIcon icon={faArrowRight} /><FontAwesomeIcon icon={faArrowLeft} /></button>
					<button onClick={this.scaleUpY}><FontAwesomeIcon icon={faArrowsAltV} /></button>
					<button onClick={this.scaleDownY}><FontAwesomeIcon icon={faArrowDown} /><FontAwesomeIcon icon={faArrowUp} /></button>
					<button onClick={this.clear}><FontAwesomeIcon icon={faBomb} /></button>
					<button onClick={this.save}><FontAwesomeIcon icon={faDownload} /></button>
		    </header>
				<Paper frames={frames} selector={this.selectFrame} selectedFrame={selectedFrame} orientation={orientation} />
		  </div>
		);
	}
}

export default App;
